// extracted by mini-css-extract-plugin
export default {"root":"ExpertStrip_root__a5tZt","avatar":"ExpertStrip_avatar__sG1QB","expertDetails":"ExpertStrip_expertDetails__1rStb"};